"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnimationLayer_1 = require("./AnimationLayer");
var ImageLayer_1 = require("./ImageLayer");
var TextLayer_1 = require("./TextLayer");
var CompositionLayer_1 = require("./CompositionLayer");
var ShapeLayer_1 = require("./ShapeLayer");
var VideoLayer_1 = require("./VideoLayer");
exports.constructLayerFromRawData = function (rawLayerData, version) {
    switch (rawLayerData.ty) {
        case AnimationLayer_1.AnimationLayerType.Text:
            return new TextLayer_1.TextLayer(rawLayerData, version);
        case AnimationLayer_1.AnimationLayerType.Image:
            return new ImageLayer_1.ImageLayer(rawLayerData, version);
        case AnimationLayer_1.AnimationLayerType.PreComp:
            return new CompositionLayer_1.CompositionLayer(rawLayerData, version);
        case AnimationLayer_1.AnimationLayerType.Shape:
            return new ShapeLayer_1.ShapeLayer(rawLayerData, version);
        case AnimationLayer_1.AnimationLayerType.Video:
            return new VideoLayer_1.VideoLayer(rawLayerData, version);
        default:
            return new AnimationLayer_1.AnimationLayer(rawLayerData, version);
    }
};
//# sourceMappingURL=AnimationLayerFactory.js.map